<template>
  <b-container fluid class="contents">
    <b-row class="mb-3">
      <b-col>
        <span class="contents-title">Web Sequence</span>
        <i class="guide-tooltip" id="contents-tooltip"></i>
        <b-popover
          target="contents-tooltip"
          triggers="hover"
          content="Change the order of how the sections of your online store will appear."
        ></b-popover>
      </b-col>
    </b-row>
    <b-row>
      <b-col v-if="isLoading" class="d-flex align-items-center justify-content-center min-height-300px">
        Loading...
      </b-col>
      <b-col v-else>
        <draggable
          :list="form"
          draggable=".draggable.-movable"
          handle=".move-handle"
          ghostClass="draggable-ghost"
          dragClass="draggable-ghost"
          @change="handleChanges(null)"
        >
          <div :class="['draggable flex-column mb-3', { '-movable': section.enable }]" v-for="(section, index) in form" :key="`section_order_${index}`">
            <b-col md="4" class="border rounded d-inline-flex align-items-center justify-content-between py-2 bg-white draggable-content">
              {{ section.name }}
              <div class="action-container d-inline-flex align-items-center">
                <switches v-model="section.enable"
                  theme="custom"
                  color="primary"
                  type-bold="true"
                  style="top: 13px; left: 10px;"
                  class="mr-4"
                  @input="handleChanges(null)"
                  :emit-on-mount="false">
                </switches>
                <img src="@/assets/images/actions/move-handle.svg" alt="move" class="move-handle mr-2" style="cursor: pointer;">
              </div>
            </b-col>
          </div>
        </draggable>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from "vuex";
import draggable from "vuedraggable";
import Switches from "vue-switches";
import _ from "lodash";

export default {
  components: { draggable, Switches },
  data() {
    return {
      form: [
        { name: "About Us", enable: false, weight: 1, key: "about_us" },
        { name: "Categories", enable: false, weight: 2, key: "categories" },
        { name: "Our Brands", enable: false, weight: 3, key: "our_brands" },
        // { name: "Featured Products", enable: false, weight: 4, key: "featured_products" },
        { name: "What's Nearby", enable: true, weight: 4, key: "whats_nearby" }
      ]
    }
  },
  computed: {
    ...mapGetters({
      isLoading: "designs/loading",
      advancedSettingsWebSequence: "designs/advancedSettingsWebSequence",
      errors: "designs/errors"
    }),
  },
  mounted() {
    this.$root.$on('handleSave', (routeName) => {
      if (routeName === 'designAdvancedSettingsWebSequence') this.saveWebSequence();
    });
    this.$root.$on('saveChangesCancelled', (value) => {
      if (value) this.form = JSON.parse(JSON.stringify(_.orderBy(this.advancedSettingsWebSequence, 'weight')));
      this.setErrors(null);
      this.$nextTick(() => {
        this.reOrderSequence();
      });
    });
  },
  beforeDestroy() {
    this.$root.$off('handleSave');
    this.$root.$off('saveChangesCancelled');
  },
  async created() {
    await this.getAdvancedSettingsWebSequence();
    this.form = JSON.parse(JSON.stringify(_.orderBy(this.advancedSettingsWebSequence, 'weight')));
    this.$nextTick(() => {
      this.setSectionOrder();
      this.reOrderSequence();
    });
  },
  methods: {
    ...mapMutations({
      setErrors: "designs/errors"
    }),
    ...mapActions({
      getAdvancedSettingsWebSequence: "designs/getAdvancedSettingsWebSequence",
      saveAdvancedSettingsWebSequence: "designs/saveAdvancedSettingsWebSequence"
    }),
    handleChanges(params) {
      this.$nextTick(() => {
        this.$root.$emit('showSaveAlert', true);
        this.reOrderSequence(true);
      });
    },
    async saveWebSequence() {
      const payload = {
        sections: {}
      };
      Object.keys(this.form).forEach(index => {
        payload.sections[`${this.form[index].key}`] = {
          enable: this.form[index].enable,
          weight: this.form[index].weight
        };
      });
      await this.saveAdvancedSettingsWebSequence(payload);
      if (!this.errors || Object.keys(this.errors).length === 0) this.$root.$emit('showSaveAlert', false);
    },
    setSectionOrder() {
      this.form.map((section, index) => {
        this.form[index].weight = Number(index) + 1;
      });
    },
    reOrderSequence(isChanged) {
      const enabledSections = [];
      const disabledSections = [];

      this.form.map(section => {
        if (section.enable) enabledSections.push(section);
        else disabledSections.push(section);
      });

      const collectedSections = enabledSections.concat(disabledSections).map((section, index) => {
        return { ...section, weight: Number(index) + 1, enable: section.enable }
      });

      this.form = _.orderBy(collectedSections, 'weight');
    }
  },
};
</script>

<style lang="scss" scoped>
.draggable-content {
  border-color: #E9EBED !important;
  box-shadow: 0px 0px 10px rgba(119, 121, 141, 0.1);
  border-radius: 10px !important;
  font-family: MainFontBold, sans-serif;
  font-weight: normal;
}
.min-height-300px {
  min-height: 300px;
}
</style>